import React, { useEffect } from 'react';
import { CareerImpact } from '../components/CareerImpact';
import { ExperienceTimeline } from '../components/ExperienceTimeline';
import { ExpertiseGrid } from '../components/ExpertiseGrid';
export function ExperiencePage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return <div className="pt-20" data-id="element-251">
      <CareerImpact data-id="element-252" />
      <ExperienceTimeline data-id="element-253" />
      <ExpertiseGrid data-id="element-254" />
    </div>;
}